import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Request } from '@core/models/requests.model';
import { StorageService } from '@core/services/storages.service';
import { WsSyncActiveItem, WsSyncActiveListResponse, WsSyncToggleCommand, WsSyncToggleResponse } from '../../domain/interfaces/ws-sync-state.types';
import { WsSyncLog, WsSyncLogsQuery, WsSyncLogsResponse } from '../../domain/interfaces/ws-sync-log.types';

const SYNC_URL = 'ia/kdb/marca/synchronize';
const LOGS_URL = 'ia/kdb/marca/synchronization/logs';
const LIST_URL = 'ia/kdb/marca/synchronization/list';

@Injectable({ providedIn: 'root' })
export class WsSyncApiService {
  private readonly request = inject(Request);
  private readonly storageService = inject(StorageService);

  synchronize(command: WsSyncToggleCommand): Observable<WsSyncToggleResponse> {
    const userInfo = this.storageService.getSessionStorage('userInfo');
    const body = {
      idMarca: command.idMarca,
      marca: command.marca,
      idSubmarca: command.idSubmarca,
      submarca: command.submarca,
      idUsuario: userInfo?.IdUsuario ?? userInfo?.data?.idUsuario ?? '',
      usuario: userInfo?.User ?? userInfo?.data?.user ?? '',
      sincronizacionActiva: command.active,
      configuracion: this.request.getConfigUser(),
    };
    return this.request.Post<WsSyncToggleResponse>(SYNC_URL, body);
  }

  getLogs(query: WsSyncLogsQuery): Observable<WsSyncLog[]> {
    const body = {
      idMarca: query.idMarca,
      idSubmarca: query.idSubmarca,
      configuracion: this.request.getConfigUser(),
    };
    return this.request
      .Post<WsSyncLogsResponse>(LOGS_URL, body)
      .pipe(map(response => response?.response ?? []));
  }

  listActive(): Observable<WsSyncActiveItem[]> {
    const body = {
      configuracion: this.request.getConfigUser(),
    };
    return this.request
      .Post<WsSyncActiveListResponse>(LIST_URL, body)
      .pipe(map(response => response?.response?.items ?? []));
  }
}
